import { useEffect, useRef } from 'react';

/** Listens to keydown on the document while `active` (Esc to close, focus traps). */
export function useDocumentKeydown(active: boolean, handler: (e: KeyboardEvent) => void): void {
  const ref = useRef(handler);
  ref.current = handler;
  useEffect(() => {
    if (!active) return;
    const listener = (e: KeyboardEvent) => ref.current(e);
    document.addEventListener('keydown', listener);
    return () => document.removeEventListener('keydown', listener);
  }, [active]);
}
